"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRollbarPerson = useRollbarPerson;

var _useRollbarConfiguration = require("./useRollbarConfiguration.js");

require("./useRollbar.js");

require("react");

require("./Provider.js");

require("./_rollupPluginBabelHelpers-e84dd01a.js");

require("rollbar");

require("./tiny-invariant.esm-a43f84cc.js");

function useRollbarPerson(person) {
  (0, _useRollbarConfiguration.useRollbarConfiguration)({
    payload: {
      person: person
    }
  });
}